import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import withLoader from 'components/organisms/withLoader';
import { scrollToErrorIfExist, showResult } from 'utils';
import Button from 'components/atoms/button';
import { Formik, Form } from 'formik';
import forms from 'constants/forms';
import useUser from 'utils/useUser';
import { isAgencyDoctor, isPractice } from 'utils/userTypeHelper';
import { Card, CardBody, Table } from 'reactstrap';
import validationSchema from 'components/organisms/adminPanels/clinics/validationSchema';
import requestBodyGenerator from 'components/organisms/adminPanels/clinics/requestBodyGenerator';
import Contact from 'components/organisms/adminPanels/clinics/components/contact';
import Address from 'components/organisms/adminPanels/clinics/components/address';
import RunBook from 'components/organisms/adminPanels/clinics/components/runBook';
import ClinicDetails from 'components/organisms/adminPanels/clinics/components/clinicDetails';
import Registration from 'components/organisms/adminPanels/clinics/components/registration';
import { useHistory } from 'react-router-dom';
import Representatives from 'components/organisms/adminPanels/clinics/components/representatives';
import Agency from 'components/organisms/adminPanels/clinics/components/agency';
import ParentClinic from 'components/organisms/adminPanels/clinics/components/parentClinic';
import ActiveStatusButton from './components/activeStatusButton';
import ActivePvrLiteButton from './components/activePvrLiteButton';

const EditClinic = () => {
  const formRegistration = [...forms.adminPanelsClinic.clinicAdd.registration];
  const { agencies, userType } = useUser();
  const {
    adminPanelClinics: { editClinic, updateStatus },
  } = useDispatch();
  const clinic = useSelector((state) => state.adminPanelClinics.clinic);
  const history = useHistory();

  const {
    getClinic: clinicDetailsLoading,
    getRepresentatives: representativesLoading,
    getAgencies: agenciesLoading,
    getThreshold: thresholdsLoading,
    getClinics: clinicsLoading,
    editClinic: submitLoading,
    updateStatus: submitLoadingStatus,
  } = useSelector((state) => state.loading.effects.adminPanelClinics);

  const submitHandler = async (clinicRequest) => {
    const body = requestBodyGenerator(clinicRequest);
    if (clinic.status !== body.status && !isPractice(userType)) {
      const { error: updateError } = await updateStatus(body);
      if (updateError) return showResult(updateError);
    }
    const { error, data } = await editClinic(body);
    if (error) return showResult(error);
    showResult();
    history.push(`/admin/clinic/${data.guid}`);
  };

  return (
    <div className="admin-patient">
      {withLoader(
        clinicDetailsLoading ||
          representativesLoading ||
          thresholdsLoading ||
          agenciesLoading ||
          clinicsLoading,
        <>
          {clinic && (
            <Card className="card-border">
              <CardBody>
                <Formik
                  onSubmit={submitHandler}
                  initialValues={{ ...clinic }}
                  validationSchema={validationSchema()}
                >
                  {({ errors, values, setFieldValue }) => (
                    <Form>
                      <div className="admin-patient-header">
                        <span>Edit Clinic</span>
                        <div className="admin-patient-header-actions">
                          <div className="admin-patient-header-actions-call">
                            <ActivePvrLiteButton
                              pvrLite={values.acceptPvrLite}
                              setFieldValue={setFieldValue}
                            />
                          </div>
                          {!isPractice(userType) && (
                            <div className="admin-patient-header-actions-status">
                              <ActiveStatusButton status={values.status} />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="admin-patient-edit-form">
                        <Table>
                          <tbody>
                            <tr>
                              <td>
                                <Contact errors={errors} values={values} />
                              </td>
                              <td>
                                <Address errors={errors} values={values} />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <Registration
                                  formRegistration={formRegistration}
                                  errors={errors}
                                  values={values}
                                />
                                <Representatives
                                  clinic={clinic}
                                  errors={errors}
                                />
                                {isAgencyDoctor(userType) && (
                                  <Agency agencies={agencies} errors={errors} />
                                )}
                                {!isPractice(userType) && (
                                  <ParentClinic
                                    agencyGuid={values?.agencyGuid}
                                    errors={errors}
                                  />
                                )}
                              </td>
                              <td>
                                <ClinicDetails
                                  errors={errors}
                                  values={values}
                                  type="clinicEdit"
                                />
                                <RunBook
                                  errors={errors}
                                  values={values}
                                  setFieldValue={setFieldValue}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                      <div className="text-center">
                        <Button
                          disabled={
                            (submitLoading || submitLoadingStatus) && errors
                          }
                          type="submit"
                          text="Save"
                          handleClick={scrollToErrorIfExist}
                        />
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          )}
        </>,
      )}
    </div>
  );
};

export default EditClinic;
